import { ethers } from 'ethers';

import { PaytrABI } from '../abi/PaytrABI';
import { ERC20ABI } from '../abi/ERC20ABI';
import { CometABI } from '../abi/CometABI';
import { FaucetABI } from '../abi/FaucetABI';

export const contractAddress = "0xDC7E3C54Cde09d6211d59f91258Ec2407ebf2d49";
export const provider = ((window.ethereum != null) ? new ethers.providers.Web3Provider(window.ethereum) : console.log("No provider"));
export const signer = (provider ? provider.getSigner() : null);
export const myContract = new ethers.Contract(contractAddress, PaytrABI, signer);
export const contractWithSigner = myContract.connect(signer);

export const cometAddress = "0xAec1F48e02Cfb822Be958B68C7957156EB3F0b6e"; //cUSDCv3 (Comet) address on Sepolia
export const comet = new ethers.Contract(cometAddress, CometABI, signer);

export const USDCaddress = "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238"; //USDC main contract address on Sepolia
export const underlyingUSDC = new ethers.Contract(USDCaddress, ERC20ABI, signer);

const fauceteerMumbai = "0x68793eA49297eB75DFB4610B68e076D2A5c7646C"; //USDC Fauceteer (Compound) on Sepolia
export const fauceteer = new ethers.Contract(fauceteerMumbai, FaucetABI, signer);

export const SEPOLIA_CHAIN_ID = "0xaa36a7"; //11155111 is the ID